import { ListData } from 'api/types/data';
import { NotificationEntity } from 'api/types/entity';
import { NotificationItemFeature } from 'components/Layout/Header/NotificationsFeature/NotificationItemFeature/NotificationItemFeature';
import { useTranslation } from 'libs/i18n';
import { Box, CircularProgress, Stack, Typography } from 'libs/ui';
import { Colors } from 'libs/ui/theme';

import { DelimiterStyled } from '../Delimiter';

import { ContentStyled, EmptyContentStyled } from './styles';

type NotificationsContentProps = {
  listData?: ListData<NotificationEntity>;
  loading?: boolean;
  lastElementRef: (node: Element) => void;
  onClosePopover: () => void;
};

export const NotificationsContent = ({
  listData,
  loading,
  lastElementRef,
  onClosePopover,
}: NotificationsContentProps) => {
  const { t } = useTranslation();

  return (
    <ContentStyled>
      <Stack flex={1}>
        {listData?.list.map((notification, index) => (
          <Box
            key={notification.id}
            ref={
              listData.list.length - 1 === index
                ? (ref) => ref && lastElementRef(ref)
                : null
            }
          >
            <NotificationItemFeature
              notification={notification}
              onClose={onClosePopover}
            />
            {index !== (listData?.total ?? 0) - 1 && <DelimiterStyled />}
          </Box>
        ))}

        {!listData?.list.length && (
          <EmptyContentStyled
            alignItems="center"
            flex={1}
            justifyContent="center"
          >
            <Typography color={Colors.black} variant="captionMedium">
              {t('components.dialogNotifications.emptyText')}
            </Typography>
          </EmptyContentStyled>
        )}

        {loading && (
          <Stack alignItems="center">
            <CircularProgress />
          </Stack>
        )}
      </Stack>
    </ContentStyled>
  );
};
